/**
 * @desc updateOutPlanStatus
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.outPlanFacadeImpl.updateOutPlanStatus.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/outPlan/updateOutPlanStatus`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
